// extracted by mini-css-extract-plugin
export default {"root":"UserIdentifiers_root__oh8qY","paper":"UserIdentifiers_paper__mNE4P","identifierData":"UserIdentifiers_identifierData__zxPnn"};